{
  "version": 1,
  "asset_id": "a9c31e17-5472-46c3-aa86-b34c31113fd8",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/a9c31e17-5472-46c3-aa86-b34c31113fd8/thumb-symbiogenesis.webp",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/a9c31e17-5472-46c3-aa86-b34c31113fd8/thumb-symbiogenesis.webp",
  "original_filename": "thumb-symbiogenesis.webp",
  "size": 57798,
  "content_type": "image/webp",
  "created_at": "2026-08-30T13:03:57Z"
}
